import gql from 'graphql-tag';

const UPDATE_ASSET_LOCATION_SEARCH_MUTATION_NAME =
  'compositions_WithAssetLocationSearch_updateAssetLocationSearchMutation';

const updateAssetLocationSearchMutation = gql`
  mutation ${UPDATE_ASSET_LOCATION_SEARCH_MUTATION_NAME} (
    $countryCode: String!,
    $location: Position,
    $searchValue: String!,
    $id: ID!,
  ) {
    updateCase(
      input: {
        id: $id,
        patch: {
          assetLocation: {
            countryCode: $countryCode
            coordinates: $location
            searchValue: $searchValue
          }
        },
      },
    ) {
      case {
        id
        assetLocation {
          countryCode
          coordinates {
            latitude
            longitude
          }
          searchValue
          address {
            city,
            country,
            postalCode,
            province,
            streetAddress,
          }
        }
      }
    }
  }
`;

export default updateAssetLocationSearchMutation;



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/DealerDetails/NewCaseFromLocation/updateAssetLocationSearchMutation.js